import urljoin from 'url-join';
import axios from 'axios';

var requestHeaders = {
  'Content-Type': 'application/json'
};
var transformRequest = function transformRequest(data) {
  if (data === void 0) {
    data = {};
  }

  if (typeof data === 'string') return data;
  return JSON.stringify(data);
};

var responseInterceptor = function responseInterceptor(response) {
  return response;
};
var exceptionInterceptor = function exceptionInterceptor(error) {
  var response = error.response;
  var tip = '故障';
  var feedbackMethod = console.warn;

  if (!response) {
    tip = '没响应';
  } else {
    var status = response ? response.status : 0;

    if (status === 404) {
      tip = '不在了';
    } else if (status === 500 && response.data.message) {
      tip = "[" + status + "] " + response.data.message;
      feedbackMethod = console.error;
    } else {
      tip = "[" + status + "] \u4E0D\u7ED9\u529B";
    }
  }

  feedbackMethod('抱歉～ ' + tip);
  console.log(typeof error.response === 'undefined' ? '' : error.response.data);
  return Promise.reject(error);
};

var SERVER_NAME = 'contract';
var HOST = process.env.HOST || 'http://api.sayyoo.cn';
var baseURL = /*#__PURE__*/urljoin(HOST, SERVER_NAME);
var ins = /*#__PURE__*/axios.create({
  baseURL: baseURL,
  headers: requestHeaders,
  transformRequest: [transformRequest],
  timeout: 10000
});
ins.interceptors.response.use(responseInterceptor, exceptionInterceptor);

var ExcelApi;

(function (ExcelApi) {
  var _basePath = 'excel';
  var _host = HOST;

  function setHost(host) {
    _host = host;
  }

  ExcelApi.setHost = setHost;

  function applyHeaders(headers) {
    for (var k in headers) {
      ins.defaults.headers.common[k] = headers[k];
    }
  }

  ExcelApi.applyHeaders = applyHeaders;

  function g() {
    for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
      parts[_key] = arguments[_key];
    }

    return urljoin.apply(void 0, [_host, SERVER_NAME, _basePath].concat(parts));
  }

  function exportSignExcel(reqContractListBean) {
    return ins.post(g('/exportSignExcel'), reqContractListBean, {
      responseType: 'blob'
    });
  }

  ExcelApi.exportSignExcel = exportSignExcel;

  function exportLeaseExcel(reqContractListBean) {
    return ins.post(g('/exportLeaseExcel'), reqContractListBean, {
      responseType: 'blob'
    });
  }

  ExcelApi.exportLeaseExcel = exportLeaseExcel;
})(ExcelApi || (ExcelApi = {}));

var ContractApi;

(function (ContractApi) {
  var _basePath = 'contract';
  var _host = HOST;

  function setHost(host) {
    _host = host;
  }

  ContractApi.setHost = setHost;

  function applyHeaders(headers) {
    for (var k in headers) {
      ins.defaults.headers.common[k] = headers[k];
    }
  }

  ContractApi.applyHeaders = applyHeaders;

  function g() {
    for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
      parts[_key] = arguments[_key];
    }

    return urljoin.apply(void 0, [_host, SERVER_NAME, _basePath].concat(parts));
  }
  /**
   * 根据合同id查询能耗配置
   * @param contractId
   */


  function getContractEnergyByContractId(contractId) {
    return ins.get(g('/get/energy/config/', contractId));
  }

  ContractApi.getContractEnergyByContractId = getContractEnergyByContractId;
})(ContractApi || (ContractApi = {}));

export { ContractApi, ExcelApi };
//# sourceMappingURL=services-contract.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-contract/dist/services-contract.esm.js
// module id = 7dt3
// module chunks = 256